export const RESET_TOKEN_KEY = 'tokenId'
export const RESET_USER_ID_KEY = 'userId'
export const REGULARIZE_STATUS_PATH_KEY = 'status'
export const CLOCKOUT_REMINDER_KEY = 'clockOutReminderId'
// React router v6 works differently and hence care should be maintained while defining routes
// A route starting with '/' is an absolute path ===> It will replace from the root of the url
// Without the slash it will append to the current URL in the address bar

const ROUTES_OBJ = {
  HOME: "/",
  LOGIN: '/login',

  ATTENDANCE_REPORT: '/attendance_report',
  ONBOARDING: '/onboarding',
  EMPLOYEES_LIST: '/employees_list',
  SOPS: "/sops",
  STANDARD_PROTOCOL: 'standard_protocol',
  MEET_THE_TEAMS: 'meet_the_teams',
  DAILY_OPERATIONS: 'daily_operation',

  // * Related to Everything JCR
  EVERYTHING_JCR: '/everything_jcr',
  KNOW_YOUR_COMPANY: 'know_your_company',
  HR_POLICIES: 'hr_policies',
  OUR_TECH_INFRASTRUCTURE: 'our_tech_infrastructure',
  GALLERY: 'gallery',
  KNOWLEDGE_REPOSITORY: 'knowledge_repository',
  LEAVES: '/leaves',
  PROFILE: '/profile',

  REGULARIZE: `/regularize/:${REGULARIZE_STATUS_PATH_KEY}`,

  // * Recruitment Related
  RECRUITMENT: '/recruitment',
  ONBOARDING: 'onboarding',
  LATERAL_HIRING: 'lateral_hiring',
  CAMPUS_PLACEMENT: 'campus_placement',
  BASIC_DETAILS: 'basic_details',
  WORK_EXPERIENCE: 'work_experience',
  BANK_DETAILS: 'bank_details',
  EDUCATION_DETAILS: 'education_details',
  ONBOARDING_SUCCESS: 'onboarding_success',
  // Clockout Reminder Related Related
  REMINDER: {
    ROOT: `/reminder/:${CLOCKOUT_REMINDER_KEY}`,
  }
}

export const ROUTES = Object.freeze(ROUTES_OBJ)
